
# appreciations

I'm grateful for...

- feeling morally validated by the company I work for.

- a boss that goes out of their way to figure out what makes me happy.

- a week off from work next week.

- 2 parents, 1 sister, 1 bro-in-law, 1 nephew, 3 aunts, 3 uncles, 8 cousins most of which I'll see next week!

- a work laptop that I have root access on.

- a company that strongly encourages open source!

- my health.

- the "short list".

# accomplishments of the day

- [CDBattaglia.com](https://cdbattaglia.com/) back up and running after full server migration
- [DTW Maps](https://downthewhole.com/) same as above
- [Keycloak](https://auth.downthewhole.com/auth/) full KC server for everything I'm about to work on
- [add sample test for actix 2 with future 0.3 by cdbattags · Pull Request #5263 · TechEmpower/FrameworkBenchmarks](https://github.com/TechEmpower/FrameworkBenchmarks/pull/5263)
- [rust-http-benchmarks/main.rs at master · cdbattags/rust-http-benchmarks](https://github.com/cdbattags/rust-http-benchmarks/blob/master/experiments/actix-03/src/main.rs)
  - compiling!
- [add rust to zshrc · cdbattags/prezto@4322072](https://github.com/cdbattags/prezto/commit/43220729a4943cc9aa98cf045bb4c10044548e94)
  - updated to include rust across all my linux envs (fish shell soon?)
- [only use first ip address in hostname cmd · cdbattags/keycloak-containers@8b3a77a](https://github.com/cdbattags/keycloak-containers/commit/8b3a77ac76a1b77cd52b6786f7594b54471cc097)
  - patched KC to only use the first IP because I was getting failures for private network
  - Docker Hub upload
- [cdbattags/cookin-dtw: all infrastructure for the "Down the Whole (aka DTW)" project](https://github.com/cdbattags/cookin-dtw)
  - the backbone of all my infrastructure that runs everything (Ubuntu 18.04 for now)
  - goal is to get provisioning done with something like Vagrant soon? but no need to ditch Chef for now
  - baking my own images soon? starting with Arch as base?

# resetting https://downthewhole.com and https://cdbattaglia.com

Each are now on two distinct Digital Ocean boxes. DTW is a 2 vCPU 2GB memory box and CDBattaglia is 1 vCPU and 1GB memory.

Fun part now is to do some benchmarks but can definitely wait.

DTW includes:
- configured with chef
- NGINX gateway
- services
  - open street map tiles
    - languages: Docker, bash, C, C++, cartocss and more
  - keycloak
    - languages: Docker, Java, Postgres
  - places of interest api
    - languages: Docker, Node.js, Redis

CDBattaglia includes:
- configured with chef
- NGINX gateway
- services
  - markdown parser for @dtw/notes
    - languages: Markdown, Node.js
  - cdbattaglia-web
    - languages: Node.js, Express
  - one square mile
    - languages: Python, Docker, geopandas, libspatial, OSM
  - lots more but moreso experiments

# actix-web officially ported to tokio 2 and future 0.3 

[Tracking issue for std::future migration · Issue #1166 · actix/actix-web](https://github.com/actix/actix-web/issues/1166)
- "it is done"
- HUGE

# looking at differences between async-std and the tokio ecosystem

[async-std - Announcing async-std 1.0](https://async.rs/blog/announcing-async-std-1-0/)
- BOOM
- ok this is going to be lovely but

# what if you could have a single static binary for your megalith Rails application?

big thing I'm looking here is I wonder if I can attempt a chef port with this...? lots of ffi but hmmm

[artichoke/artichoke: 💎 Artichoke is a Ruby made with Rust](https://github.com/artichoke/artichoke)
- single binary rails apps
- https://docs.google.com/document/d/1O9mQSe36cYAQ7HNLUWH5Iyb-U8OfLE3qBgtgQBimtGs/edit
- PORT of CHEF?!
- [artichoke/artichoke-frontend at master · artichoke/artichoke](https://github.com/artichoke/artichoke/tree/master/artichoke-frontend)

# I'd love to add the language bar calculation for the repo that runs this website

2 different calculations:
- all repos "private access included" on GitHub
- this website repo aka "cdbattaglia-web"

to add on my homepage:
- [github/linguist: Language Savant. If your repository's language is being reported incorrectly, send us a pull request!](https://github.com/github/linguist)

# I'm trying to identify a title in my field that combines product and software engineering... v hard

[Software Roles and Titles - JavaScript Scene - Medium](https://medium.com/javascript-scene/software-roles-and-titles-e3f0b69c410c)
- [Becoming a Full Stack Product Person | Brian Casel](https://briancasel.com/full-stack-product-person/)
- [How Is A Product Engineer Different From A Full-Stack Engineer?](https://www.forbes.com/sites/quora/2017/09/06/how-is-a-product-engineer-different-from-a-full-stack-engineer/#1d24503226e7)
- [Fullstack Engineer - Product Engineering | Twitch | LinkedIn](https://www.linkedin.com/jobs/view/fullstack-engineer-product-engineering-at-twitch-1468904137/)
- [Titles and Promotions in Product and Engineering | LinkedIn](https://www.linkedin.com/pulse/titles-promotions-product-engineering-parker-barrile/)
- [Product Engineer (Full Stack) — Careers at Atoms](https://atoms.com/pages/product-engineer-full-stack)
- [product sofware Jobs in United States | LinkedIn](https://www.linkedin.com/jobs/search/?currentJobId=1606967189&geoId=103644278&keywords=product%20sofware&location=United%20States)
- titles
  - Product Software Engineer
  - Product Full Stack Engineer
  - Full Stack Product Engineer
  - Technical Product Manager
  - Technical Product Owner

# awesome vid about the whole async/await journey

[Rust's Journey to Async/Await - YouTube](https://www.youtube.com/watch?v=lJ3NC-R3gSI)

# a whole day's worth of content going step by step through Rust port of ConcurrentHashMap

[Porting Java's ConcurrentHashMap to Rust - YouTube](https://www.youtube.com/watch?v=yQFWmGaFBjk)

# link-y-poos

📚:
- [cdbattags/rust-http-benchmarks: Just benchmarking various HTTP server approaches in Rust.](https://github.com/cdbattags/rust-http-benchmarks)
- [migrate actix-web to std::future · actix/actix-web@08678d5](https://github.com/actix/actix-web/commit/08678d5f394070063ff0482754d29510261ccee1)
- [entropic-dev/entropic: 🦝 a package registry for anything, but mostly javascript 🦝 🦝 🦝](https://github.com/entropic-dev/entropic)
- [Figma is powered by WebAssembly](https://www.figma.com/blog/webassembly-cut-figmas-load-time-by-3x/)
- [Successfully Merging the Work of 1000+ Developers – Shopify Engineering](https://engineering.shopify.com/blogs/engineering/successfully-merging-work-1000-developers)
- [Basic Social Skills Guide - Improve Your Social Skills](https://www.improveyoursocialskills.com/basic-social-skills-guide)
- [anelson/tracers: Ergonomic Rust bindings for instrumenting Rust apps with high performance probes using SystemTap, DTrace, etc](https://github.com/anelson/tracers)
- [Decentralized, offline-first, realtime collaboration with Automerge - YouTube](https://www.youtube.com/watch?v=L9fdyDlhByM&feature=youtu.be)
- [Local-first software: you own your data, in spite of the cloud – the morning paper](https://blog.acolyer.org/2019/11/20/local-first-software/)
- [Barbara Liskov Is the Architect of Modern Algorithms | Quanta Magazine](https://www.quantamagazine.org/barbara-liskov-is-the-architect-of-modern-algorithms-20191120/)
- [jgraph/drawio-desktop: Official electron build of draw.io](https://github.com/jgraph/drawio-desktop)
- [firecracker-microvm/firecracker: Secure and fast microVMs for serverless computing.](https://github.com/firecracker-microvm/firecracker)
- [Ruby Under a Microscope: An Illustrated Guide to Ruby Internals: Pat Shaughnessy: 9781593275273: Amazon.com: Books](https://www.amazon.com/Ruby-Under-Microscope-Illustrated-Internals/dp/1593275277)
- [tjpalmer/async-demo: Rust async/await demo with parallel requests](https://github.com/tjpalmer/async-demo)
- [The C10K problem](http://www.kegel.com/c10k.html)
